import { Injectable } from '@angular/core';
import { Features, ModuleNames } from '../../model/account-definition';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { UserAccountService } from '../user-account.service';

@Injectable()
export class CommonPricelistsGuardService {
  constructor(
    private _userAccount: UserAccountService,
    private _navigation: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this._userAccount.current.pipe(
      map(account => {
        if (account.hasAccess(ModuleNames.Common, Features.ManagePricelists)) return true;

        this._navigation.navigatePageNotFound();
        return false;
      })
    );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
